import { render, staticRenderFns } from "./SubMigrationsCard.vue?vue&type=template&id=7c1286db&"
import script from "./SubMigrationsCard.vue?vue&type=script&lang=js&"
export * from "./SubMigrationsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c1286db')) {
      api.createRecord('7c1286db', component.options)
    } else {
      api.reload('7c1286db', component.options)
    }
    module.hot.accept("./SubMigrationsCard.vue?vue&type=template&id=7c1286db&", function () {
      api.rerender('7c1286db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Migrations/SubMigrationsCard.vue"
export default component.exports